import { USER_STATUS } from 'utils/constants/roles';
import { PAGE_URLS } from 'utils/constants';
import { hasFeature } from 'utils/helper/product';
import uniqBy from 'lodash/uniqBy';
import { optionalFormField } from 'utils/methods/helpers';
import API from 'services/api';
import { transform as siteListTransform } from 'utils/DataTransform/Sites/SitesList';
import { setSiteName } from 'utils/helper/site';

export const departmentFilter = transformedDepartmentList => {
  return optionalFormField({
    showWhen: transformedDepartmentList.length > 0,
    field: [
      {
        label: 'departments',
        field: 'departmentId',
        type: 'select',
        options: [
          ...transformedDepartmentList,
          { id: 'EMPTY_DEPARTMENT', name: 'No department' },
        ],
      },
    ],
  });
};

const statusOptionForFilter = ({
  currentView,
  hasAttendanceTrackingFeature,
}) => {
  if (currentView === PAGE_URLS.EMERGENCIES.link) {
    return [USER_STATUS.AVAILABLE, USER_STATUS.ON_INTERRUPTABLE_TASK];
  } else if (hasAttendanceTrackingFeature) {
    return [
      USER_STATUS.AVAILABLE,
      USER_STATUS.NOT_LOGGED_IN,
      USER_STATUS.ON_BREAK,
      USER_STATUS.ON_TASK,
      USER_STATUS.ON_INTERRUPTABLE_TASK,
      USER_STATUS.UNAVAILABLE,
    ];
  } else {
    return [
      USER_STATUS.AVAILABLE,
      USER_STATUS.NOT_LOGGED_IN,
      USER_STATUS.ON_TASK,
      USER_STATUS.ON_INTERRUPTABLE_TASK,
    ];
  }
};

export const filters = ({
  currentView,
  serviceRoleMap,
  userAssignedDepartments = [],
  availableRoles,
  subscribedFeatures,
  securityCompanyId,
}) => {
  const hasAttendanceTrackingFeature = hasFeature({
    subscribeFeatures: subscribedFeatures,
    feature: 'ATTENDANCE_TRACKING',
  });
  const filterTypes = {
    RegularFilters: [
      {
        label: 'Archived',
        field: 'archived',
        type: 'toggle',
      },
      {
        label: 'role',
        field: 'role',
        type: 'select',
        options: availableRoles,
      },
    ],
    AdvancedFilters: [
      {
        label: 'service',
        field: 'service',
        type: 'select',
        options: serviceRoleMap.reduce((prev, curr) => {
          prev.push(...curr.allowableServices);
          return uniqBy(prev, 'id');
        }, []),
      },
      {
        label: 'Site',
        field: 'site',
        type: 'async-select',
        useAsyncInFilters: true, // if you are using async-select in filters make sure this is set to true
        fetchOptions: API.fetchSitesList,
        fetchFilters: {
          securityCompanyId,
          archived: false,
        },
        optionLabelKey: 'name',
        dataTransform: ({ data }) => {
          const transformedNameSites = data.map(site => ({
            ...site,
            id: site.id,
            name: setSiteName(site),
          }));
          return siteListTransform(
            transformedNameSites,
            userAssignedDepartments,
          );
        },
      },
      {
        label: 'status',
        field: 'status',
        type: 'select',
        options: statusOptionForFilter({
          currentView,
          hasAttendanceTrackingFeature,
        }),
      },
      ...departmentFilter(userAssignedDepartments),
    ],
  };
  return filterTypes;
};
